import {
  createRef,
  Fragment,
  FunctionComponent,
  useEffect,
  useState,
} from "react";
import { IRetailerMaster, RetailerMasterListProps } from "./IRetailerMaster";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAppDispatch, useAppSelector } from "../../redux/hooks/Hooks";
import { Button, Dialog, DialogContent, DialogTitle } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import RetailerMasterForm from "./RetailerMasterForm";
import CompletePopup from "../components/response-pop-up";
import { clearCreateRetailerMaster } from "../../redux/retail-master/createRetailerMaster";
import { clearEditRetailerMaster } from "../../redux/retail-master/editRetailerMaster";

const RetailerMasterList: FunctionComponent<RetailerMasterListProps> = ({
  open,
  setOpen,
  ...props
}) => {
  const [isEdit, setEdit] = useState<boolean>(false);
  const [initialValues, setInitialValues] = useState<IRetailerMaster>({
    active: true,
  });
  const [responsePopup, setResponsePopup] = useState<boolean>(false);
  const [responseEdit, setResponseEdit] = useState<boolean>(false);

  const fileRep = createRef<any>();
  const dispatch = useAppDispatch();

  const stateOpetionList: any = useAppSelector((state) => state.GeneralSetting);

  const { isLoading: createReatilerLoading, data: createRetailer } =
    useAppSelector((state) => state.CreateRetailerMaster);

  const { isLoading: editRetailerLoading, data: editRetailer } = useAppSelector(
    (state) => state.EditRetailerMaster
  );
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEdit(false);
  };
  const { retailer } = props;

  useEffect(() => {
    if (
      Object.keys(editRetailer ?? {}).length ||
      Object.keys(createRetailer ?? {}).length
    ) {
      handleClose();
    }
  }, [editRetailer, createRetailer]);
  return (
    <Fragment>
      <div className="content_header justify-content-end">
        <div className="btns">
          <Button
            className="common_btn_outline"
            disableRipple
            onClick={() => {
              handleClickOpen();
              setInitialValues(retailer ?? {});
            }}
          >
            Edit User
            <FontAwesomeIcon icon="edit" title="Edit partner onboarding" />
          </Button>
        </div>
      </div>

      <div className="scroll_content_container scroll_content_container_2">
        <div className="grid_container">
          <div className="detail_item">
            <label className="f4">Retailer Name</label>
            <p>{retailer?.name}</p>
          </div>
          <div className="detail_item">
            <label className="f4">Retailer Type</label>
            <p>{retailer?.type}</p>
          </div>
          <div className="detail_item">
            <label className="f4">Address Line1</label>
            <p>{retailer?.address1}</p>
          </div>
          <div className="detail_item">
            <label className="f4">Address Line2</label>
            <p>{retailer?.address2 ? retailer?.address2 : "--"}</p>
          </div>
          <div className="detail_item">
            <label className="f4">Gst NO</label>
            <p>{retailer?.gst ? retailer?.gst : "--"}</p>
          </div>
          <div className="detail_item">
            <label className="f4">City</label>
            <p>{retailer?.city}</p>
          </div>
          <div className="detail_item">
            <label className="f4">State</label>
            <p>
              {stateOpetionList?.data?.result?.find((e: any) => {
                return e.name === retailer?.state;
              })?.description ?? null}
            </p>
          </div>
          <div className="detail_item">
            <label className="f4">Contact Name</label>
            <p>{retailer?.contact_name}</p>
          </div>
          <div className="detail_item">
            <label className="f4">Contact Number</label>
            <p>{retailer?.contact_number}</p>
          </div>
          <div className="detail_item">
            <label className="f4">Email</label>
            <p>{retailer?.email}</p>
          </div>
          <div className="detail_item">
            <label className="f4">Comments</label>
            <p>{retailer?.comments ? retailer?.comments : "--"}</p>
          </div>
          <div className="detail_item">
            <label className="f4">Status</label>
            <p>{retailer?.active ? "Active" : "InActive"}</p>
          </div>
        </div>
      </div>

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth={"md"}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div className="dialog_header common_border_bottom">
          <h4 id="alert-dialog-title" className="f4">
            {"Add Retailer"}
          </h4>

          <CancelIcon
            onClick={() => {
              handleClose();
            }}
          />
        </div>
        <RetailerMasterForm
          initialValues={initialValues}
          handleClose={handleClose}
          setInitialValues={setInitialValues}
        />
      </Dialog>

      <CompletePopup
        data={{ data: createRetailer }}
        responsePopup={Object.keys(createRetailer ?? {}).length}
        setCompletePopup={(e: any) => {
          dispatch(clearCreateRetailerMaster());
          setResponsePopup(false);
        }}
      />
      <CompletePopup
        data={{ data: editRetailer }}
        responsePopup={Object.keys(editRetailer ?? {}).length}
        setCompletePopup={(e: any) => {
          dispatch(clearEditRetailerMaster());
          setResponseEdit(false);
        }}
      />
    </Fragment>
  );
};

export default RetailerMasterList;
